import { render } from "./GettingStartedOverview.vue?vue&type=template&id=22f8023e&scoped=true"
import script from "./GettingStartedOverview.vue?vue&type=script&lang=js"
export * from "./GettingStartedOverview.vue?vue&type=script&lang=js"

import "./GettingStartedOverview.vue?vue&type=style&index=0&id=22f8023e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f8023e"]])

export default __exports__